// extracted by mini-css-extract-plugin
export var compactFilters = "_dl-4";
export var detailImage = "_dl-1";
export var dropdownContainer = "_dl-2";
export var imageContainer = "_dl-0";
export var selectedCard = "_dl-3";